import axios from "axios";
import { pollUntil, isBatchFinished } from "./pollUntil.mjs";

const API_BASE = process.env.VUE_APP_API_BASE || "https://rwapi.ntustmeg.com";

export { pollUntil, isBatchFinished };

// 用法：
//   const handle = pollBatch(batchId, { onUpdate: (s) => (this.summary = s) });
//   const summary = await handle.promise;     // 完成時的 summary；被 cancel 時為 null
//   beforeDestroy() { handle.cancel(); }
export function pollBatch(batchId, options = {}) {
  return pollUntil(
    () => axios.get(`${API_BASE}/api/jobs/batch/${encodeURIComponent(batchId)}`).then((res) => res.data),
    isBatchFinished,
    options
  );
}
